import Icon from 'veui/components/Icon'

Icon.register({
  'star-filled': {
    paths: [
      {
        d: 'M745.64 295.42A32 32 0 00720 273.66l-211.68-31.8-95.69-191.49a32 32 0 00-57.26 0l-95.65 191.49L48 273.66a32 32 0 00-17.7 54.45l152.61 150.15-35.17 211.15a32 32 0 0046.32 33.65L384 624.36l189.94 98.7a32 32 0 0046.32-33.65l-35.17-211.15 152.57-150.15a32 32 0 007.98-32.69z'
      }
    ],
    width: '768',
    height: '768'
  }
})
